import React, { useState, useEffect } from "react";
import useUploadsQueries from "../../../store/uploads/uploadsQueries";
import StudentTable from "./StudentTable";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import { Fade } from "@mui/material";
import loader from "../../../assets/gifs/loader.gif";

const JobRecordsTable = ({ jobId, jobType, status }) => {
  const [downloadClicked, setDownloadClicked] = useState(false);

  const handleDownloadClick = () => {
    setDownloadClicked(true);
    setTimeout(() => setDownloadClicked(false), 2000);
  };

  const { data, isLoading, error, refetch } = useUploadsQueries().useJobRecords(
    jobId,
    jobType,
    status
  );

  useEffect(() => {
    if (refetch) {
      refetch();
    }
  }, [refetch, jobId, jobType, status]);

  if (isLoading) {
    return (
      <div className="bulk-upload-jobs-error-loading-container">
        <img
          src={loader}
          alt="Loading..."
          style={{ height: "200px", width: "200px" }}
        />
      </div>
    );
  }

  if (error) {
    return <p>Error loading job records: {error.message}</p>;
  }

  const records = data?.records || [];
  const failedRecordsUrl = data?.failed_records_url;

  if (records.length === 0) {
    return <p>No records found for this job.</p>;
  }

  const columns = Object.keys(records[0]).map((key) => ({
    key: key,
    label: key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
  }));

  return (
    <div className="job-records-table-container">
      {failedRecordsUrl && (
        <div className="download-button-container">
          <a
            href={failedRecordsUrl}
            download
            className="download-button"
            onClick={handleDownloadClick}
          >
            <span>Download Failed Records</span>
            <span className="download-icon-container">
              <Fade in={!downloadClicked} timeout={300}>
                <span className="download-icon">
                  <DownloadIcon />
                </span>
              </Fade>
              <Fade in={downloadClicked} timeout={300}>
                <span className="download-icon">
                  <DownloadDoneIcon />
                </span>
              </Fade>
            </span>
          </a>
        </div>
      )}
      <StudentTable data={records} columns={columns} />
    </div>
  );
};

export default JobRecordsTable;
